import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ButtonWrapper = styled(motion.button)`
  padding: ${props => props.size === 'small' ? '8px 20px' : '15px 35px'};
  border-radius: 50px;
  font-size: ${props => props.size === 'small' ? '0.9rem' : '1.1rem'};
  font-weight: 600;
  border: 2px solid #EABE00;
  font-family: lexend;
  cursor: pointer;
  position: relative;
  background: transparent;
  transition: all 0.3s ease;
  z-index: 1;
  overflow: hidden;
  width: ${props => props.$fullWidth ? '100%' : 'auto'};
  text-align: ${props => props.$fullWidth ? 'left' : 'center'};
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease;
    z-index: -1;
    border-radius: 50px;
  }
`;

const PrimaryButtonStyled = styled(ButtonWrapper)`
  color: #000;

  &::before {
    background: linear-gradient(135deg, #F49097 0%, #EABE00 100%);
  }

  &:hover {
    background: linear-gradient(135deg, #F49097 0%, #EABE00 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &:hover::before {
    background: ${props => props.theme === "light" ? "#fff" : "#000"};
    opacity: 0;
  }
`;

const SecondaryButtonStyled = styled(ButtonWrapper)`
  color: #000;

  &::before {
    background: linear-gradient(135deg, #EABE00 0%, #F49097 100%);
  }

  &:hover {
    background: linear-gradient(135deg, #F49097 0%, #EABE00 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &:hover::before {
    opacity: 0;
    background: ${props => props.theme === "light" ? "#fff" : "#000"};
  }
`;

const Button = ({ 
  text, 
  link, 
  onClick, 
  variant = 'primary', 
  className = '', 
  fullWidth = false,
  theme = 'light',
  size = 'default'
}) => {
  const ButtonComponent = variant === 'primary' ? PrimaryButtonStyled : SecondaryButtonStyled;
  
  const isInternalLink = link && link.startsWith('/');
  
  if (link) {
    if (isInternalLink) {
      return (
        <Link to={link} className={className}>
          <ButtonComponent
            as="span"
            $fullWidth={fullWidth}
            theme={theme}
            size={size}
            $whiletap={{ scale: 0.98 }}
          >
            {text}
          </ButtonComponent>
        </Link>
      );
    }
    return (
      <a href={link} className={className}>
        <ButtonComponent
          as="span"
          $fullWidth={fullWidth}
          theme={theme}
          size={size}
          $whiletap={{ scale: 0.98 }}
        >
          {text}
        </ButtonComponent>
      </a>
    );
  }

  return (
    <ButtonComponent
      onClick={onClick}
      className={className}
      $fullWidth={fullWidth}
      theme={theme}
      size={size}
      $whiletap={{ scale: 0.98 }}
    >
      {text}
    </ButtonComponent>
  );
};

export default Button; 